var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  fill: "#7D7D7D",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "HOME",
  transform: "translate(-16.000000, -39.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Components/Top-bar/Normal",
  transform: "translate(16.000000, 39.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu",
  transform: "translate(3.000000, 3.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Line-3",
  points: "18 1.3 18 2.7 0 2.7 0 1.3"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line-3-Copy",
  points: "18 8.3 18 9.7 0 9.7 0 8.3"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line-3-Copy-2",
  points: "18 15.3 18 16.7 0 16.7 0 15.3"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuIcon);
export default ForwardRef;